import { Box, Container, Divider, Stack, Typography, useTheme } from "@mui/material"

import MuiBreadcrumbs from "../../../common/breadcrumbs"

const DesktopWrapper = ({ title, children, subTitle = "", icon = null }) => {
  const theme = useTheme()

  return (
    <Container
      sx={{
        position: "relative",
        ml: 2,
        minHeight: "90%",
        borderRadius: 4,
        background: theme.palette.mode === "dark" ? "#232424" : "#fff"
      }}
    >
      <Box sx={{ pt: 2, mb: 4 }}>
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <Stack>
            <Stack direction='row' alignItems='start' spacing={1.5}>
              <Typography variant='h4' fontWeight='normal' color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>
                {title}
              </Typography>
            </Stack>

            <MuiBreadcrumbs />
          </Stack>
        </Stack>

        <Divider sx={{ mt: 3 }} />
      </Box>

      {children}
    </Container>
  )
}

export default DesktopWrapper
